export const VIDEO_GENERATOR_CONFIG_TAB_ID = 'config'
